// extracted by css-extract-rspack-plugin
export default {"statusIndicator":"TriageAgentButton-module__statusIndicator__lxJKSJP","pulse":"TriageAgentButton-module__pulse__d0b8frG"};